import React from "react";
import './index.css'
import { useSelector } from "react-redux";
import PostCard from "../../../../components/PostCard";
import { sortByRecentDate } from "../../../../utils/sortArray";

const ListSearchPlayerPost = ()=>{
    const allPost = useSelector(state => state?.searchPlayer?.allPost)
    const sortedRecentPost = sortByRecentDate(allPost) || []
    
    return(
        <div className="list-searchpalyer-post-container">
            <div className="list-searchpalyer-post-subcontainer">
                {
                    sortedRecentPost?.map(post =>{
                        return(
                            <PostCard post={post} />
                        )
                    })
                }

            </div>
        </div>

    )
}

export default ListSearchPlayerPost